module.exports = __webpack_public_path__ + "static/media/wellness_badge.b2d912ec.png";